export default {
      id: "icon-arrow-usage",
      viewBox: "0 0 15 13",
      url: __webpack_public_path__ + "dist/sprite.svg#icon-arrow",
      toString: function () {
        return this.url;
      }
    }